var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuttingActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6152 0.0827026C26.5106 0.128441 26.3538 0.239521 26.2819 0.324463C26.1578 0.461678 22.4334 6.38153 22.0283 7.08067C21.9499 7.22442 21.878 7.44004 21.878 7.56419C21.878 7.74714 20.5451 10.0275 15.1741 19.0445L8.47014 30.2961L8.26758 30.27C7.36588 30.1524 1.81848 29.7146 1.4591 29.7342C0.707688 29.7865 0.250304 30.1067 0.0542829 30.7274C-0.115602 31.2632 0.139225 32.6876 0.459394 32.9882C0.537802 33.06 0.707688 33.145 0.838369 33.1777C0.962516 33.2103 2.74631 33.2887 4.79147 33.3475C8.90138 33.4652 9.26729 33.4521 9.91416 33.1319C10.6852 32.7529 10.7636 32.2041 10.1886 31.3089L9.9403 30.9234L16.5593 19.8286C22.4595 9.92952 23.2044 8.71418 23.4266 8.5835C23.6357 8.45282 23.995 7.92356 25.805 5.00938C26.9811 3.1341 27.9743 1.5202 28.02 1.43525C28.1311 1.21963 28.0657 0.677303 27.9089 0.461678C27.6018 0.0500336 27.0399 -0.113316 26.6152 0.0827026Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuttingActiveIcon);
export default __webpack_public_path__ + "static/media/puttingActiveIcon.5f4562c898f39383efd7cf5d3d983e5b.svg";
export { ForwardRef as ReactComponent };